import AirLogo from './images/icon_air.svg';
import ArrowBreadcrumbs from './images/icon_arrow_breadcrumbs.svg';
import ArrowDropdown from './images/icon_arrow_dropdown.svg';
import ArrowLeft from './images/icon_arrow_left.svg';
import ArrowsSidenavi from './images/icon_arrows_sidenavi.svg';
import CheckOff from './images/icon_check_off.svg';
import CheckOn from './images/icon_check_on.svg';
import CheckToast from './images/icon_check_toast.svg';
import Close from './images/icon_close.svg';
import Item from './images/icon_item.svg';
import Question from './images/icon_question.svg';
import Search from './images/icon_search.svg';
import Shop from './images/icon_shop.svg';
import SortArrow from './images/icon_sort_arrow.svg';
import SortHandle from './images/icon_sort_handle.svg';
import UserGroup from './images/icon_user_group.svg';
import User from './images/icon_user.svg';
import ExternalLink from './images/icon_external_link.svg';
import CheckboxArrow from './images/icon_checkbox_arrow.svg';
import CheckboxHyphen from './images/icon_checkbox_hyphen.svg';
import File from './images/icon_file.svg';
import Success from './images/icon_success.svg';
import Download from './images/icon_download.svg';
import Trash from './images/icon_trash.svg';
import Edit from './images/icon_edited.svg';
export default {
    AirLogo: AirLogo,
    ArrowBreadcrumbs: ArrowBreadcrumbs,
    ArrowDropdown: ArrowDropdown,
    ArrowLeft: ArrowLeft,
    ArrowsSidenavi: ArrowsSidenavi,
    CheckOff: CheckOff,
    CheckOn: CheckOn,
    CheckToast: CheckToast,
    Close: Close,
    File: File,
    Item: Item,
    Question: Question,
    Search: Search,
    Shop: Shop,
    SortArrow: SortArrow,
    SortHandle: SortHandle,
    UserGroup: UserGroup,
    User: User,
    ExternalLink: ExternalLink,
    CheckboxArrow: CheckboxArrow,
    CheckboxHyphen: CheckboxHyphen,
    Success: Success,
    Download: Download,
    Trash: Trash,
    Edit: Edit,
};
//# sourceMappingURL=icon-svgs.js.map